/* ============================================
   SUVENE — Mobile Search Hijack
   Mobile Mega-Nav Suchlupe → Desktop Quick-Search Overlay
   ============================================ */

(function() {
  'use strict';

  function initMobileSearchHijack() {
    // Mobile Mega-Nav Search-Trigger finden
    const mobileSearchTrigger = document.querySelector('.su-nav-search-trigger');
    if (!mobileSearchTrigger) return;

    // Desktop search-drawer Trigger finden
    const searchDrawer = document.querySelector('search-drawer');
    const searchDrawerTrigger = searchDrawer 
      ? searchDrawer.querySelector('[rel="toggle-search"]') 
      : null;

    if (!searchDrawer || !searchDrawerTrigger) {
      console.warn('[Suvene] search-drawer not found — mobile search hijack skipped');
      return;
    }

    // Mobile Mega-Nav Drawer (zum Schließen)
    const megaNavDrawer = document.querySelector('#su-mega-nav-drawer');
    const megaNavOverlay = document.querySelector('#su-mega-nav-overlay');
    const megaNavCloseBtn = document.querySelector('[data-su-nav-close]');

    mobileSearchTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // 1. Mobile Mega-Nav schließen
      if (megaNavCloseBtn) {
        megaNavCloseBtn.click();
      } else if (megaNavDrawer) {
        megaNavDrawer.classList.remove('is-open');
        if (megaNavOverlay) megaNavOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      // 2. Kurz warten bis Drawer-Schließen-Animation durch ist
      setTimeout(function() {
        // 3. Desktop Search-Drawer triggern
        searchDrawerTrigger.click();
      }, 300);
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileSearchHijack);
  } else {
    initMobileSearchHijack();
  }
})();